<!-- 
個人別入力件数or個人別ログイン状況一覧画面
@props
  headerText : ヘッダー文言
  itemList : 集計情報
-->

<template>
  <div>
    <div class="ml-2 text-h5">{{ this.$parent.usageTitle }}</div>
    <v-col>
      <v-btn color="primary" outlined @click.stop="onClickBack"
        ><v-icon class="mr-2">mdi-arrow-left</v-icon>一覧へ</v-btn>
    </v-col>
    <template>
      <v-row class="ma-0" align="start">
        <v-col cols="auto" class="ma-0 pd-0 mt-2">表示年：</v-col>
        <v-col cols="auto" class="ma-0" style="width: 340px">
          <v-select
            class="mx-4"
            outlined
            dense
            hide-details
            v-model="dispYear"
            :items="this.$parent.selectDispYears"
            @input="onInputYear"
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <v-data-table
      locale="jp"
      mobile-breakpoint="0"
      v-model="selectGroupId"
      class="usageTable"
      :headers="headers"
      :fixed-header="true"
      :items="itemList"
      item-key="producerNumOrName"
      hide-default-footer
      :search="searchCondition"
      :custom-filter="executeSearch"
      :single-select="false"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      @page-count="pageCount = $event"
      no-results-text="検索条件に合うデータがありません"
      no-data-text="データがありません"
    >
      <!-- 表ヘッダ部のボタン -->
      <template v-slot:top>
        <!-- 表上部の検索フィールド -->
        <v-row class="mb-0" align="center">
          <v-col cols="auto" sm="8" md="5" lg="3" xl="3">
            <v-text-field
              v-model="search"
              class="mx-4"
              outlined
              dense
              hide-details
              @keyup.enter.exact="requestToSearch"
            >
              <template v-slot:prepend>
                <v-icon>mdi-magnify</v-icon>
              </template>
              <template v-slot:append-outer>
                <v-btn
                  outlined
                  color="primary"
                  style="margin-top: -6px"
                  @click="requestToSearch"
                  >生産者検索</v-btn
                >
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </template>
      <!-- テーブルのコンテンツの定義 -->
      <template v-slot:[`item.groupName`]="{ item }">
        <div class="pl-4">
        {{ item.groupName }}
        </div>
      </template>
    </v-data-table>
    <!-- 表下部の表示件数フィールド -->
    <template>
      <v-row class="ma-0" align="start">
        <v-col cols="auto">
          表示件数：
        </v-col>
        <v-col cols="auto" style="width: 150px;">
          <v-select
            class="mx-4"
            outlined
            dense
            hide-details
            style="margin-top: -6px"
            v-model="itemsPerPage"
            :items="numRowsItems"
          ></v-select>
        </v-col>
      </v-row>
    </template>
    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ["headerText", "itemList"],
  components: {
  },
  computed: {
  },
  data() {
    this.selectedType = 0;

    // 1ページあたりの表示件数リスト
    const numRowsItems = [5, 10, 25, 50, 100];

    return {
      // 表示年
      dispYear: this.$parent.dispYear,
      // 検索条件（入力中）
      search: "",
      // 検索条件（一覧反映中）
      searchCondition: "",
      // タイトル
      title: this.usageTitle,
      // 表示中のページ番号
      page: 1,
      // ページ数
      pageCount: 0,
      // ページあたりに表示する件数
      itemsPerPage: 10,
      // 件数リスト
      numRowsItems: numRowsItems,
      // 選択中のユーザー情報
      selectGroupId: [],
      // 一覧のヘッダ定義
      headers: [
        {
          text: this.headerText[0],
          align: "start",
          value: "groupName",
          class: "grey darken-1 white--text pl-8",
          sortable: false,
          filterable: false,
          width: "80px",
        },
        {
          text: this.headerText[1],
          align: "start",
          value: "producerNumOrName",
          class: "grey darken-1 white--text",
          sortable: false,
          width: "80px",
        },
        {
          text: this.headerText[2],
          align: "center",
          value: "productNum[0]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[3],
          align: "center",
          value: "productNum[1]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[4],
          align: "center",
          value: "productNum[2]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[5],
          align: "center",
          value: "productNum[3]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[6],
          align: "center",
          value: "productNum[4]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[7],
          align: "center",
          value: "productNum[5]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[8],
          align: "center",
          value: "productNum[6]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[9],
          align: "center",
          value: "productNum[7]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[10],
          align: "center",
          value: "productNum[8]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[11],
          align: "center",
          value: "productNum[9]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[12],
          align: "center",
          value: "productNum[10]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
        {
          text: this.headerText[13],
          align: "center",
          value: "productNum[11]",
          class: "grey darken-1 white--text",
          sortable: false,
          filterable: false,
          width: "50px",
        },
      ],
    };
  },
  methods: {
    /**
     * 生産記録入力者数・ログイン数の切り替え
     */
    onChangeType() {
      this.$emit("on-change-type", this.selectedType);
    },
    /**
     * 一覧へボタンがクリックされたらグループ一覧表示に切り替える
     */
    onClickBack() {

      this.$emit("on-click-back");
    },
    /**
     * 表示年が選択されたらデータ再取得
     */
    onInputYear() {
      this.$emit("on-input-year", this.dispYear);
    },
    /**
     * 検索条件を一覧に反映する
     */
    requestToSearch() {
      this.searchCondition = this.search;
    },
    /**
     * 検索を実施する
     */
    executeSearch(item, search) {
      if (search == null || (typeof(item) === 'string' && item.includes(search))) {
        return true;
      }

      return false;
    },
  },
};
</script>

<style>
.usageTable {
  border-bottom: solid 2px #E3E3E3;
}
.usageTable th {
  font-size: 14px !important;
}
.usageTable td {
  font-size: 14px !important;
  border-right: solid 2px #F3F3F3;
}
.usageTable div.v-data-table__wrapper{
  max-height: 600px;
  overflow-x: auto;
  overflow-y: auto;
}
th {
  background-color: #757575 !important;
}
th.sortable .v-data-table-header__icon {
  color: rgb(255, 255, 255, 0.15) !important;
}
th.sortable.active .v-data-table-header__icon {
  color: rgb(255, 255, 255, 1) !important;
}
</style>
